import { type ReactNode, useState } from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/admin/coaching/coaching-dashboard/shared/tooltip'
import {
  MOCK_TOPIC_REASONS,
  MOCK_TOPIC_RECOMMENDATIONS,
} from '../../_mock-data/library'
import { useCoachingStore } from '../../store'
import { BrowseTable } from './browse-table'

const TOPICS = Object.keys(MOCK_TOPIC_RECOMMENDATIONS)

export function TopicTab(): ReactNode {
  const { curriculum } = useCoachingStore()
  const [selectedTopic, setSelectedTopic] = useState('Heaps')
  const reason = MOCK_TOPIC_REASONS[selectedTopic]
  const recommendations = MOCK_TOPIC_RECOMMENDATIONS[selectedTopic] ?? []

  if (curriculum.persisted) {
    return (
      <p className="rounded-lg border border-dashed border-(--cd-border-2) px-3 py-4 text-[11px] text-(--cd-text-faint)">
        No recommendations yet — recommendations will appear here once
        generated.
      </p>
    )
  }

  const clearFilters = (): void => {
    curriculum.setFilters([])
    curriculum.setSorts([])
    curriculum.setTypeFilter('all')

    for (const tag of curriculum.companyTags) {
      curriculum.cycleCompanyTag(tag.company)
      if (tag.mode === 'include') curriculum.cycleCompanyTag(tag.company)
    }
  }

  return (
    <div className="space-y-2 xl:flex xl:min-h-0 xl:flex-1 xl:flex-col">
      <div className="flex flex-wrap gap-1 xl:shrink-0">
        {TOPICS.map((topic) => {
          const selected = topic === selectedTopic
          return (
            <Tooltip key={topic}>
              <TooltipTrigger asChild>
                <button
                  type="button"
                  aria-pressed={selected}
                  onClick={() => setSelectedTopic(topic)}
                  className="rounded-full border px-2.5 py-1 text-[10px] font-semibold transition-colors"
                  style={{
                    borderColor: selected
                      ? 'var(--cd-purple)'
                      : 'var(--cd-border-2)',
                    background: selected
                      ? 'color-mix(in oklab, var(--cd-purple) 12%, transparent)'
                      : 'transparent',
                    color: selected
                      ? 'var(--cd-purple)'
                      : 'var(--cd-text-muted)',
                  }}
                >
                  {topic}
                </button>
              </TooltipTrigger>
              <TooltipContent>✦ {MOCK_TOPIC_REASONS[topic]}</TooltipContent>
            </Tooltip>
          )
        })}
      </div>

      <p className="text-[10px] font-semibold text-(--cd-purple)">✦ {reason}</p>

      <BrowseTable
        items={recommendations}
        variant="topic"
        emptyState={
          <div className="flex flex-wrap items-center gap-2 rounded-lg border border-(--cd-border) bg-(--cd-card) px-3 py-3">
            <span className="text-[11px] text-(--cd-text-faint)">
              0 recommendations match the active filters.
            </span>
            <button
              type="button"
              onClick={clearFilters}
              className="rounded-full border border-(--cd-border-2) px-3 py-1 text-[10px] font-semibold text-(--cd-text-muted) hover:text-(--cd-text)"
            >
              Clear filters
            </button>
          </div>
        }
      />
    </div>
  )
}
